// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"915492a8","47":"915492a8","233":"915492a8","455":"915492a8","585":"915492a8","763":"915492a8","772":"915492a8","801":"b08cae02","833":"915492a8","873":"915492a8","886":"915492a8","888":"915492a8"}[chunkId] + ".chunk.css";
};